module.exports = __webpack_public_path__ + "static/media/Edit.104dc2a3.svg";